import { render, staticRenderFns } from "./DiscountCodesList.vue?vue&type=template&id=5f268b40&scoped=true"
import script from "./DiscountCodesList.vue?vue&type=script&lang=js"
export * from "./DiscountCodesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f268b40",
  null
  
)

export default component.exports